import React from "react";
import "./About.css";

function About() {
  return (
    <main className="about">
      {/* HERO */}
      <section className="about__hero">
        <div className="about__heroInner">
          <span className="about__badge">Shyne Graphics Corp.</span>

          <h1>
            We help brands <span className="about__shine">shine</span> with bold design
            & smart marketing.
          </h1>

          <p className="about__sub">
            From logo and brand identity to websites and campaigns — we create visuals
            that look great and help people take action.
          </p>

          <div className="about__chips">
            <span className="chip">Branding</span>
            <span className="chip">Web Design</span>
            <span className="chip">Social Ads</span>
            <span className="chip">Print Design</span>
          </div>

          <div className="about__ctaRow">
            <a className="about__ctaPrimary" href="/contact">Get a free proposal</a>
            <a className="about__ctaGhost" href="/services">View services</a>
          </div>
        </div>
      </section>


    </main>
  );
}

export default About;
